import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CardGrid } from './section';
import { TourCard } from './tour-card';
import type { Tour } from '@todo/core/tours';

import css from './tour-grid.module.css';

/** Cards shown at first, and added by each "Show more" press. */
export const TOURS_PAGE_SIZE = 12;

// A list page's tour cards, a page at a time: the whole list is already in the
// page's seed, so "Show more" only reveals the next cards — no fetch. A new
// list (the /tours search narrowing it) starts again from the first page.
export function TourGrid({ tours }: { tours: Tour[] }) {
  const { t } = useTranslation();
  const [shown, setShown] = useState(TOURS_PAGE_SIZE);

  useEffect(() => setShown(TOURS_PAGE_SIZE), [tours]);

  const rest = tours.length - shown;
  return (
    <>
      <CardGrid>
        {tours.slice(0, shown).map((tour) => (
          <TourCard key={tour.id} tour={tour} />
        ))}
      </CardGrid>
      {rest > 0 ? (
        <div className={css.moreRow}>
          <button type="button" className={css.moreButton} onClick={() => setShown((n) => n + TOURS_PAGE_SIZE)}>
            {t('tours.showMore', { count: Math.min(rest, TOURS_PAGE_SIZE) })}
          </button>
        </div>
      ) : null}
    </>
  );
}
